import request from '@/utils/request'


// la lista delle request e' una custom API perche'
// mi serve anche la lista delle drugs
export function getList (entity, filters, pagination) {
  const method = 'get'
  const url = '/fullyused/list'

  //issue 316 - modifica date da-a
  for(var t in filters)
  {
    if (t.indexOf("_$$$_from") > -1)
    {
      var oldval1 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_from')[0]] = '>='+ oldval1
    }
    if (t.indexOf("_$$$_to") > -1)
    {
      var oldval2 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_to')[0]] = '<='+ oldval2
    }
  }
  //issue 316 - modifica date da-a

  return request({
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    },
    url, method
  })
}

// fullyused ha una chiamata speciale perche' serve sapere se il protocol scelto ha labels o meno tra le drugs
export function getProtocols(search) {
  const method = 'get'
  const url = `/fullyused/protocol/${search}`
  return request({
    url,
    method
  })
}

export function confirmFullyused(id, data) {
  const method = 'post'
  const url = `/fullyused/confirm/${id}`
  return request({
    url,
    method,
    data
  })
}

export function validDrugLabels(drug_id) {
  if (!drug_id) return Promise.resolve([])
  const method = 'get'
  const url = '/drug'
  const filter = { id: drug_id }
  const ret = request({
    url, method,
    headers: { 'x-filters': JSON.stringify(filter) }
  })

  return ret.then(r => {
    return {
      data:
        r.data[0].labels.map(label => ({ label }))
    }
  })
}

export function onsiteLabels(search, protocol_id, site_id) {
  const method = 'get'
  const url = '/balance'

  let data = { protocol_id, site_id, place: 'SITE', n_pieces: '>0', 'drug.packaging': 'Labels' }

  // search for lot.no
  if (search) {
    data['drug.name'] = `%${search}%`
  }


  return request({
    url, method,
    headers: { 'x-filters': JSON.stringify(data) }
  })
}

export function onsiteDrugs(search, protocol_id, site_id, drug_id) {
  const method = 'get'
  const url = '/balance'

  let data = { protocol_id, site_id, drug_id, place: 'SITE', n_pieces: '>0', 'drug.packaging': '!=Labels' }

  // search for lot.no
  if (search) {
    if (drug_id) {
      data.lotto = `%${search}%`
    } else { // or drug name
      data['drug.name'] = `%${search}%`
    }
  }


  return request({
    url, method,
    headers: {
      'X-filters': JSON.stringify(data),
      'X-pagination': JSON.stringify({ rowsPerPage: null })
    }
  })
}
